//NOTE: This is a work around until they fix the underlying issue
// LINK HERE >> https://github.com/logaretm/vee-validate/issues/4862
import {
   Form,
   Field,
   ErrorMessage,
   FieldArray,
   defineRule,
} from "vee-validate";

export default defineNuxtPlugin((nuxtApp) => {
   // Custom password confirmation rule
   defineRule("confirmed", (value: unknown, [target]: [unknown]) => {
      if (!value) {
         return "This is a required field";
      }
      if (value === target) {
         return true;
      }
      return "Passwords must match";
   });



   nuxtApp.vueApp.component("VeeForm", Form);
   nuxtApp.vueApp.component("VeeField", Field);
   nuxtApp.vueApp.component("ErrorMessage", ErrorMessage);
   nuxtApp.vueApp.component("VeeFieldArray", FieldArray);
});
